import Nullstack from 'nullstack';
export default function IconDirectionsOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-directions-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12 21v-4"
  }), "   ", Nullstack.element("path", {
    d: "M12 13v-1"
  }), "   ", Nullstack.element("path", {
    d: "M12 5v-2"
  }), "   ", Nullstack.element("path", {
    d: "M10 21h4"
  }), "   ", Nullstack.element("path", {
    d: "M8 8v1h1m4 0h6l2 -2l-2 -2h-10"
  }), "   ", Nullstack.element("path", {
    d: "M14 14v3h-8l-2 -2l2 -2h7"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}